import * as React from 'react';

import CollectionPlus16 from './CollectionPlus16';

export const collectionPlus16 = () => <CollectionPlus16 />;

export default {
    title: 'Icon|Fill|CollectionPlus16',
    component: CollectionPlus16,
    parameters: {
        notes: "`import CollectionPlus16 from 'box-ui-elements/es/icon/fill/CollectionPlus16';`",
    },
};
